/* globals jQuery, iconPath, cancelUrl */
(function rrInit() {
    document.addEventListener('DOMContentLoaded', () => {
        /* eslint-disable */
        jQuery.fn.raty.defaults.path = iconPath;
        jQuery('#cancel_btn').click(function(e) {
            e.preventDefault();
            window.location = cancelUrl;
        });
        /**
        Large stars for overall rating
        */
        jQuery('.star-large').raty({
            cancel: false,
            click: function(score, evt) {
                raty_click(this, score, evt);
            },
            hints: ['Terrible', 'Poor', 'Average', 'Good', 'Excellent'],
            score: function() {
                return raty_score(this);
            },
            starOff: 'star-review-grey.png',
            starOn: 'star-yellow.png',
            target: '.rating-value',
            targetKeep: true
        });
        /**
        Smaller stars for value, quality, service, responsiveness
        */
        jQuery('.star').raty({
            cancel: false,
            click: function(score, evt) {
                raty_click(this, score, evt);
            },
            hints: ['Terrible', 'Poor', 'Average', 'Good', 'Excellent'],
            score: function() {
                return raty_score(this);
            },
            starOff: 'star-review-grey-small.png',
            starOn: 'star-review-blue-small.png'
        });

        function raty_click(obj, score, evt) {
            /**
            Set the appropriate hidden radio button field to the given score:
            */
            var star_id = jQuery(obj).attr('id');
            if (score) {
                //set rating:
                var id_score = score - 1;
                var field_id = "id_" + star_id + "_" + id_score;
                jQuery('input[id="'+field_id+'"]').prop('checked', true);
            } else {
                //set rating to none:
                var current_val = jQuery('input:radio[name="'+star_id+'"]:checked').val();
                if (current_val) {
                    var id_score = current_val - 1;
                    var field_id = "id_" + star_id + "_" + id_score;
                    $('input[id="'+field_id+'"]').prop('checked', false);
                }
            }
        }

        function raty_score(obj) {
            /**
            Set the score based on the hidden rating radio button values:
            */
            var star_id = $(obj).attr('id');
            var field_id;
            for (var i = 0;i <= 4;i++) {
                field_id = "id_" + star_id + "_" + i;
                if ($('input[id="'+field_id+'"]').prop('checked')) {
                    return i + 1;
                }
            }
            return null;
        }
        /* eslint-enable */
    }, false);
}());
